import React from 'react'
const bubbleStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  background: '#eef1f4',
  borderRadius: '16px',
  padding: '4px 8px 4px 12px',
  margin: '4px 8px 4px 0',
  fontSize: '13px'
}

const bubbleRemoveStyle = {
  marginLeft: '8px',
  cursor: 'pointer',
  fontWeight: 'bold',
  color: '#888',
  padding: '0 4px'
}

const EsccRecipientsListUI = ({ toEmails, newToEmail, errorList,
    onRemoveClick, onNewToChange, onAddToClick
  }) =>
  <div className='su_escc_recipients'>
    <div className='g_flex_h'>
     <span className='g_large'><b>ICICI ESCC Account Recipients</b></span>
    </div>
    {
      errorList && errorList.length > 0 &&
      <div className='g_error g_small g_m_top_50'>{errorList[0].message || 'Something went wrong'}</div>
    }
    <RecipientGroupUI
label='Send Email to'
      emails={toEmails}
      listType='to'
      newEmail={newToEmail}
      onNewChange={onNewToChange}
      onAddClick={onAddToClick}
      onRemoveClick={onRemoveClick}
    />
  </div>

const RecipientGroupUI = ({ label, emails, listType, newEmail, onNewChange, onAddClick, onRemoveClick }) =>
  <div className='su_escc_recipients_group g_m_top_100'>
    <span className='g_muted g_small'><b>{label}</b></span>
    <div style={{ marginTop: '8px' }}>
      {
        (!emails || emails.length === 0) &&
        <span className='g_muted g_small'>No recipients yet</span>
      }
      {
        (emails || []).map((email, i) =>
          <span key={i} style={bubbleStyle}>
            {email}
            <span style={bubbleRemoveStyle} onClick={() => onRemoveClick(listType, email)}>×</span>
          </span>
        )
      }
    </div>
   <div className='g_flex_h g_m_top_50'>
      <span
        style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '16px', marginRight: '8px' }}
        onClick={onAddClick}
      >+</span>
      <input
        type='text'
        className='g_input'
        placeholder='Add email address'
        value={newEmail || ''}
        onChange={onNewChange}
      />
    </div>
  </div>

export default EsccRecipientsListUI